import { render, staticRenderFns } from "./EditNewPhone.vue?vue&type=template&id=559d80ee&scoped=true"
import script from "./EditNewPhone.vue?vue&type=script&lang=js"
export * from "./EditNewPhone.vue?vue&type=script&lang=js"
import style0 from "./EditNewPhone.vue?vue&type=style&index=0&id=559d80ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559d80ee",
  null
  
)

export default component.exports